module.exports = __webpack_public_path__ + "static/media/track-vir.b9c6bab5.png";


//////////////////
// WEBPACK FOOTER
// ./html/assets/images/track-vir.png
// module id = 1041
// module chunks = 0